// Theme objects bridged to CSS variables for backward compatibility
// New components should use CSS variables directly (var(--dp-*))
// These objects exist so existing components using inline styles continue to work

export const darkTheme = {
  // Backgrounds
  bg: '#141414',
  bgSecondary: '#1C1C1C',
  bgCard: '#242424',
  card: '#242424',
  input: '#2E2E2E',
  bgSidebar: '#191919',
  bgElevated: '#303030',
  bgCardHover: '#2C2C2C',

  // Textos
  text: '#F5F5F5',
  textSecondary: '#A0A0A0',
  textTertiary: '#666666',

  // Accents (brand blue)
  accent: '#0DAEFF',
  accentHover: '#0B8FDB',
  cyan: '#0DAEFF',
  cyanHover: '#0B8FDB',

  // Borders
  border: 'rgba(255, 255, 255, 0.06)',
  borderMedium: 'rgba(255, 255, 255, 0.10)',
  borderStrong: 'rgba(255, 255, 255, 0.16)',

  // Gradientes
  gradientPrimary: 'linear-gradient(135deg, #0DAEFF, #0B8FDB)',

  // Sombras
  shadowCard: '0 8px 24px rgba(0, 0, 0, 0.3)',
  shadowCardHover: '0 12px 32px rgba(0, 0, 0, 0.4)',

  // Status
  green: '#34D399',
  yellow: '#FBBF24',
  orange: '#FB923C',
  red: '#F87171',
  purple: '#A78BFA',

  // Flag
  isDarkMode: true,
};

export const lightTheme = {
  // Backgrounds
  bg: '#FAFAFA',
  bgSecondary: '#F2F2F2',
  bgCard: '#FFFFFF',
  card: '#FFFFFF',
  input: '#F0F0F0',
  bgSidebar: '#FFFFFF',
  bgElevated: '#FFFFFF',
  bgCardHover: '#F8F8F8',

  // Textos
  text: '#1A1A1A',
  textSecondary: '#666666',
  textTertiary: '#999999',

  // Accents (brand blue - same in both modes)
  accent: '#0DAEFF',
  accentHover: '#0B8FDB',
  cyan: '#0DAEFF',
  cyanHover: '#0B8FDB',

  // Borders
  border: 'rgba(0, 0, 0, 0.06)',
  borderMedium: 'rgba(0, 0, 0, 0.10)',
  borderStrong: 'rgba(0, 0, 0, 0.16)',

  // Gradientes
  gradientPrimary: 'linear-gradient(135deg, #0DAEFF, #0B8FDB)',

  // Sombras
  shadowCard: '0 4px 12px rgba(0, 0, 0, 0.1)',
  shadowCardHover: '0 8px 20px rgba(0, 0, 0, 0.15)',

  // Status
  green: '#34D399',
  yellow: '#FBBF24',
  orange: '#FB923C',
  red: '#F87171',
  purple: '#A78BFA',

  // Flag
  isDarkMode: false,
};
